import {
  closeSplitView,
  type OpenSplitViewPayload,
  openSplitView,
  updateSplitViewContent,
} from '@saaga/shared/store/slices/split-view.slice'
import { useAppDispatch, useAppSelector } from '@saaga/shared/store/store'
import { useCallback } from 'react'

export interface UseSplitViewResult {
  isOpen: boolean
  contextId: string | null
  contentType: string | null
  contentId: string | null
  contentData: Record<string, unknown> | null
  panelPercent: number | null
  open: (payload: OpenSplitViewPayload) => void
  close: () => void
  updateContent: (data: Record<string, unknown>) => void
}

export const useSplitView = (): UseSplitViewResult => {
  const dispatch = useAppDispatch()
  const state = useAppSelector((s) => s.splitView)

  const open = useCallback(
    (payload: OpenSplitViewPayload) => {
      dispatch(openSplitView(payload))
    },
    [dispatch]
  )

  const close = useCallback(() => {
    dispatch(closeSplitView())
  }, [dispatch])

  const updateContent = useCallback(
    (data: Record<string, unknown>) => {
      dispatch(updateSplitViewContent({ contentData: data }))
    },
    [dispatch]
  )

  return {
    isOpen: state.isOpen,
    contextId: state.contextId,
    contentType: state.contentType,
    contentId: state.contentId,
    contentData: state.contentData,
    panelPercent: state.panelPercent,
    open,
    close,
    updateContent,
  }
}
